export const OVERALL_BUSINESS_PROFILE_STATUS_LABELS = {
  ONBOARDED: 'Linked',
  COMPLETED: 'Completed',
};

export const OVERALL_BUSINESS_PROFILE_STATUS_COLORS = {
  ONBOARDED: 'info',
  COMPLETED: 'success',
};

export const BUSINESS_PROFILE_COMPLETED_STATUS = 'COMPLETED';

export const isBusinessProfileComplete = (profile) => profile?.status === BUSINESS_PROFILE_COMPLETED_STATUS;
